import { Languages } from 'lucide-react';
import { LOCALE_LABELS } from '@/shared/i18n/locale-labels';
import { localeStore } from '@/shared/i18n/locale-store';
import { LOCALES, type Locale } from '@/shared/i18n/locales';
import { useLocale } from '@/shared/i18n/use-locale';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Button } from '@/shared/ui/button/button';
import { DropdownMenu } from '@/shared/ui/dropdown-menu/dropdown-menu';
import { DropdownMenuContent } from '@/shared/ui/dropdown-menu/dropdown-menu-content';
import { DropdownMenuGroup } from '@/shared/ui/dropdown-menu/dropdown-menu-group';
import { DropdownMenuLabel } from '@/shared/ui/dropdown-menu/dropdown-menu-label';
import { DropdownMenuRadioGroup } from '@/shared/ui/dropdown-menu/dropdown-menu-radio-group';
import { DropdownMenuRadioItem } from '@/shared/ui/dropdown-menu/dropdown-menu-radio-item';
import { DropdownMenuTrigger } from '@/shared/ui/dropdown-menu/dropdown-menu-trigger';

const BROWSER = 'browser';

/** The language: the person's choice or the browser's. Language names are in their own language. */
export function LocaleMenu() {
  const { t } = useTranslation();
  const locale = useLocale();
  const chosen = localeStore.chosen() ?? BROWSER;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={<Button variant="ghost" size="sm" aria-label={t('Language')} title={t('Language')} />}
      >
        <Languages /> <span className="text-xs font-semibold uppercase">{locale.slice(0, 2)}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t('Language')}</DropdownMenuLabel>
          {/* The values are BROWSER and the supported locales. */}
          <DropdownMenuRadioGroup
            value={chosen}
            onValueChange={(value) => localeStore.set(value === BROWSER ? null : (value as Locale))}
          >
            <DropdownMenuRadioItem value={BROWSER}>{t('Same as the browser')}</DropdownMenuRadioItem>
            {LOCALES.map((value) => (
              <DropdownMenuRadioItem key={value} value={value}>
                {LOCALE_LABELS[value]}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
